<div class="main-track">
    <div (wheel)="onScroll($event)" id="{{elementId}}">
    </div>
    <div id="wave-timeline"></div>
</div>